import { Box } from "@mui/material";
import FilterMenu from "../../../../components/filters/FilterMenu";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { EntityTypeInfo } from "../components/constants";
import SmartFilterButton from "./smartFilters/SmartFilterButton";
import { createEmptyFilters } from "./smartFilters/utils";
import { ALL_OPTION_NAME, filterName } from "./utils";

const getEntityTypeOptions = (fetchedEntities) => {
  const types = new Set(fetchedEntities.map((entity) => entity.entity_type));
  return [
    {
      name: ALL_OPTION_NAME,
      label: "All entity types",
      displayName: "All",
    },
    ...Array.from(types).map((type) => {
      const displayTypeName = EntityTypeInfo[type].title;
      const Icon = EntityTypeInfo[type].icon;
      return {
        name: type,
        label: (
          <Box display="flex" gap={1} alignItems="center">
            <SvgToIcon IconLogo={Icon} width={"18px"} />
            {displayTypeName}
          </Box>
        ),
        displayName: displayTypeName,
      };
    }),
  ];
};

export const getAllEntitiesFilters = (params) => {
  const filters = [
    <FilterMenu
      key="entityType"
      filterName={"Entity Type"}
      fieldName={filterName.ENTITY_TYPE}
      options={getEntityTypeOptions(params.fetchedEntities)}
      appliedFilters={params.appliedFilters}
      setAppliedFilters={params.setAppliedFilters}
    />,
    <SmartFilterButton
      key={"favorite"}
      text={"My favorites"}
      selected={params.appliedFilters[filterName.MY_FAVORITES]}
      disabled={false}
      onClick={() => {
        const updatedFilters = createEmptyFilters(params.appliedFilters);
        updatedFilters[filterName.MY_FAVORITES] = true;
        params.setAppliedFilters(updatedFilters);
      }}
      onRemove={() => {
        params.setAppliedFilters((prev) => createEmptyFilters(prev));
      }}
    />,
  ];

  return filters;
};
